import { render, staticRenderFns } from "./BulkApproverEditorDialog.vue?vue&type=template&id=08720fc4"
import script from "./BulkApproverEditorDialog.vue?vue&type=script&lang=js"
export * from "./BulkApproverEditorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports